import { render } from "./HomeLatestProducts.vue?vue&type=template&id=978cfc94"
import script from "./HomeLatestProducts.vue?vue&type=script&lang=js"
export * from "./HomeLatestProducts.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp\\www\\GuideParis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__